import { render, staticRenderFns } from "./Subscribe.vue?vue&type=template&id=644fc58a&scoped=true&"
import script from "./Subscribe.vue?vue&type=script&lang=js&"
export * from "./Subscribe.vue?vue&type=script&lang=js&"
import style0 from "./Subscribe.vue?vue&type=style&index=0&id=644fc58a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644fc58a",
  null
  
)

export default component.exports